
import { IGetDataSourceMeasureSummaryParameters } from "./IGetDataSourceMeasureSummaryParameters";


export class GetDataSourceMeasureSummaryParameters implements IGetDataSourceMeasureSummaryParameters
{
    dataSourceId: number = 0;
    date: Date = new Date();
}
